import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=29c502e0&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiEventWidgetSubtitle: require('/var/web/bet777.es/themes/dark/ui/EventWidget/Subtitle.vue').default,MarketLine: require('/var/web/bet777.es/components/market/line.vue').default})
